import styled from "@emotion/styled";
import { InputContainer } from "../../registerUserWidgetStyle";

export const UserFormRadioContainer = styled(InputContainer)`
  margin-bottom: 1rem;
`;
